/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

export const GetSouscriptionCustomerGranteesCitiesAndPostalCodesQuery = gql`
  query GetSouscriptionCustomerGranteesCitiesAndPostalCodesQuery($search: String) {
    getSouscriptionCustomerGranteesCitiesAndPostalCodes_souscription_customer_grantees(search: $search) {
      postalCodes {
 value  
label  
}
      cities {
 value  
label  
}
    }
  }
`;

export default GetSouscriptionCustomerGranteesCitiesAndPostalCodesQuery;
